import React from "react";
import FormAlert from "./FormAlert";

const ApiErrorMessage = () => (
  <FormAlert
    severity="error"
    text="Der skete en fejl ved indsendelse. Prøv venligst igen senere"
    title="Der skete en fejl."
  />
);

export default ApiErrorMessage;
